import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type PinterestIconProps = React.ComponentPropsWithRef<'svg'> & {
    forceLightMode?: boolean;
    size?: number;
    color?: string;
    className?: string;
};

export function PinterestIcon({
    forceLightMode = false,
    size = 20,
    color,
    ...restProps
}: PinterestIconProps) {
    const { isDarkMode } = useDarkMode();
    const darkMode = isDarkMode && !forceLightMode ? isDarkMode() : false;

    if (darkMode) {
        return (
            <svg
                data-testid="logo-pinterest"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <g clipPath="url(#clip0_120_4077)">
                    <path
                        d="M12.017 0C5.396 0 0.0289993 5.367 0.0289993 11.987C0.0289993 17.066 3.187 21.404 7.647 23.149C7.542 22.2 7.448 20.746 7.688 19.71C7.907 18.773 9.094 13.753 9.094 13.753C9.094 13.753 8.735 13.033 8.735 11.972C8.735 10.309 9.702 9.061 10.903 9.061C11.927 9.061 12.421 9.83 12.421 10.749C12.421 11.778 11.768 13.316 11.429 14.741C11.144 15.934 12.029 16.906 13.204 16.906C15.332 16.906 16.972 14.661 16.972 11.419C16.972 8.558 14.909 6.55 11.964 6.55C8.554 6.55 6.555 9.112 6.555 11.749C6.555 12.782 6.949 13.892 7.444 14.49C7.543 14.61 7.556 14.715 7.529 14.835C7.439 15.21 7.236 16.034 7.195 16.198C7.142 16.423 7.023 16.469 6.794 16.363C5.299 15.673 4.361 13.485 4.361 11.717C4.361 7.941 7.109 4.465 12.281 4.465C16.439 4.465 19.673 7.432 19.673 11.388C19.673 15.523 17.066 18.85 13.44 18.85C12.226 18.85 11.086 18.221 10.682 17.471L9.933 20.319C9.664 21.364 8.929 22.671 8.435 23.465C9.558 23.81 10.741 24 11.985 24C18.592 24 23.97 18.635 23.97 12.013C23.97 5.39 18.592 0.026 11.985 0.026L12.017 0Z"
                        fill={color ?? 'white'}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_120_4077">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            data-testid="logo-pinterest"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <g clipPath="url(#clip0_120_4079)">
                <path
                    d="M12.017 0C5.396 0 0.0289993 5.367 0.0289993 11.987C0.0289993 17.066 3.187 21.404 7.647 23.149C7.542 22.2 7.448 20.746 7.688 19.71C7.907 18.773 9.094 13.753 9.094 13.753C9.094 13.753 8.735 13.033 8.735 11.972C8.735 10.309 9.702 9.061 10.903 9.061C11.927 9.061 12.421 9.83 12.421 10.749C12.421 11.778 11.768 13.316 11.429 14.741C11.144 15.934 12.029 16.906 13.204 16.906C15.332 16.906 16.972 14.661 16.972 11.419C16.972 8.558 14.909 6.55 11.964 6.55C8.554 6.55 6.555 9.112 6.555 11.749C6.555 12.782 6.949 13.892 7.444 14.49C7.543 14.61 7.556 14.715 7.529 14.835C7.439 15.21 7.236 16.034 7.195 16.198C7.142 16.423 7.023 16.469 6.794 16.363C5.299 15.673 4.361 13.485 4.361 11.717C4.361 7.941 7.109 4.465 12.281 4.465C16.439 4.465 19.673 7.432 19.673 11.388C19.673 15.523 17.066 18.85 13.44 18.85C12.226 18.85 11.086 18.221 10.682 17.471L9.933 20.319C9.664 21.364 8.929 22.671 8.435 23.465C9.558 23.81 10.741 24 11.985 24C18.592 24 23.97 18.635 23.97 12.013C23.97 5.39 18.592 0.026 11.985 0.026L12.017 0Z"
                    fill={color ?? '#BD081C'}
                />
            </g>
            <defs>
                <clipPath id="clip0_120_4079">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
